module.exports = __webpack_public_path__ + "img/vegetable-beets-350x184.14e48bd3.jpg";